export default "__VITE_ASSET__TwQt$E_9__"